export default "__VITE_ASSET__b9144f2d__"